export const ROWS_PER_PAGE = [10, 20, 50, 100];

/** Default page size for paginated DataTables. */
export const DEFAULT_ROWS_PER_PAGE = 20;
